import {formatCurrency, formatNumber} from '@angular/common';

import { DetailScreen } from '../mapping-classes/detail-screen';
import { DetailPanel } from '../mapping-classes/detail-panel';
import { DetailLabel } from '../mapping-classes/detail-label';
import { ButtonData } from '../mapping-classes/button-data';

export class Importincasso implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Import Incasso';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || 'Import Incasso';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues() {
    let product: DetailPanel = this.panels[0];
    this.fillProductFeatures(product);

    product = this.panels[1];
    this.fillProductAgreements(product);

    product = this.panels[2];
    this.fillProductUsage(product);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    let productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductFeatures(productDetailsPanel, obj);

    productDetailsPanel = this.panels[1];
    this.addValuesToProductAgreements(productDetailsPanel, obj);

    productDetailsPanel = this.panels[2];
    this.addValuesToProductUsage(productDetailsPanel, obj);
  }

  addButtons(response) {
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductFeatures(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('referenceNumber', new DetailLabel('Referentienummer'));
    productDetailsPanel.nameAndValues.set('collectionConditionDesc', new DetailLabel('Soort Incasso'));
    productDetailsPanel.nameAndValues.set('drawerPartyName', new DetailLabel('Drawer'));
    productDetailsPanel.nameAndValues.set('draweePartyName', new DetailLabel('Drawee'));
    productDetailsPanel.nameAndValues.set('collectionAddConditionDesc', new DetailLabel(''));
  }

  private addValuesToProductFeatures(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('referenceNumber').setValue(obj.referenceNumber || '-');
    productDetailsPanel.nameAndValues.get('collectionConditionDesc').setValue(obj.collectionConditionDesc || '-');
    productDetailsPanel.nameAndValues.get('collectionAddConditionDesc').setValue(obj.collectionAddConditionDesc || '-');
    productDetailsPanel.nameAndValues.get('drawerPartyName').setValue(obj.drawer || '-');
    productDetailsPanel.nameAndValues.get('draweePartyName').setValue(obj.drawee || '-');
  }

  private fillProductAgreements(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('startDate', new DetailLabel('Openingsdatum'));
    productDetailsPanel.nameAndValues.set('maturityDate', new DetailLabel('Vervaldatum'));
    productDetailsPanel.nameAndValues.set('endDate', new DetailLabel('Einddatum'));
    productDetailsPanel.nameAndValues.set('openingAmountInEur', new DetailLabel( 'Opening bedrag EUR'));
    productDetailsPanel.nameAndValues.set('openingAmount', new DetailLabel('Opening bedrag VV'));
    productDetailsPanel.nameAndValues.set('remittingBankPartyName', new DetailLabel('Ontvangende bank'));
    productDetailsPanel.nameAndValues.set('remittingBankCountryName', new DetailLabel('Land van de bank'));
  }

  private addValuesToProductAgreements(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('startDate').setValue(obj.startDate || '-');
    productDetailsPanel.nameAndValues.get('maturityDate').setValue(obj.maturityDate || '-');
    productDetailsPanel.nameAndValues.get('endDate').setValue(obj.endDate || '-');
    productDetailsPanel.nameAndValues.get('openingAmountInEur').setValue((obj.openingAmountInEur &&
      formatCurrency(obj.openingAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('openingAmount').setValue(
      this.numberFormat(obj.openingAmount, obj.openingAmountCurrencyCode) || '-'); //formating number concatenate
    productDetailsPanel.nameAndValues.get('remittingBankPartyName').setValue(obj.remittingBankPartyName || '-');
    productDetailsPanel.nameAndValues.get('remittingBankCountryName').setValue(obj.remittingBankCountryName || '-');
  }

  private fillProductUsage(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('openAmountInEur', new DetailLabel('Openstaand bedrag EUR'));
    productDetailsPanel.nameAndValues.set('openAmount', new DetailLabel('Openstaand bedrag VV'));
    productDetailsPanel.nameAndValues.set('docsReceivedDate', new DetailLabel('Geadviseerd aan klant'));
  }

  private addValuesToProductUsage(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('openAmountInEur')
      .setValue((obj.openAmountInEur && formatCurrency(obj.openAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('openAmount')
      .setValue(this.numberFormat(obj.openAmount, obj.openAmountCurrencyCode) || '-');
    productDetailsPanel.nameAndValues.get('docsReceivedDate')
      .setValue(obj.docsReceivedDate || '-');
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  public numberFormat(num: number, currency: string) {
    if (!(num && currency)) {
      return null;
    }
    return `${formatNumber(num, 'nl-NL', '2.2-5')} ${currency}`
  }
}
